import { render, staticRenderFns } from "./ofd.vue?vue&type=template&id=03d444da&"
import script from "./ofd.vue?vue&type=script&lang=js&"
export * from "./ofd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports